import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import Button from 'react-bootstrap/lib/Button';

import { translate as t } from '../../lib/I18n';
import { PaymentAuthCodes } from '../../constants/AppConstants';
import { PaymentUnauthorizedError } from '../../errors/Payment';
import { ACTError } from '../../errors/Smartcard';

import Icon from '../general/Icon';


function PaymentError ({ error, message, onRetry, retryLabel }) {
    if (!message) {
        let errorMessage;
        let messageKey;
        if (error instanceof ACTError) {
            messageKey = 'confirmation.externalError';
            errorMessage = t('confirmation.externalErrorMessage');
        } else {
            messageKey = _.result(PaymentAuthCodes, errorMessage) ? `payment.error.${errorMessage}` : 'payment.error.UNKNOWN_ERROR';
            errorMessage = _.get(error, 'message');
        }
        message = t(messageKey, { message: errorMessage});
    }

    return (
        <div className="confirmation text-center js-payment-result" data-error={message || error}>
            <Icon icon="clear margin-bottom--sm otrl-xl" />
            <p className="alert-danger text-weight--normal">{ t('confirmation.decline') }</p>
            <p className="text-sm margin-bottom">{ message }</p>
            {onRetry && (
                <Button bsStyle="default" onClick={ onRetry }>
                    { t(retryLabel) }
                    <Icon className="pull-left otrl-rotate-180" icon="chevron" />
                </Button>
            ) }
        </div>
    );
}


PaymentError.propTypes = {
    error: PropTypes.oneOfType([
        PropTypes.instanceOf(PaymentUnauthorizedError),
        PropTypes.instanceOf(ACTError),
    ]),
    message: PropTypes.string,
    onRetry: PropTypes.func,
    retryLabel: PropTypes.string,
};

PaymentError.defaultProps = {
    onRetry: null,
    retryLabel: 'confirmation.backToPayment'
};


export default PaymentError;



// WEBPACK FOOTER //
// ./src/components/checkout/PaymentError.js